module.exports = __webpack_public_path__ + "img/cert_envirothon_asia.a3e1cd22.png";